/* 
  src/reducers/registerReducer.js
*/
export default (state = { data : ""}, action) => {
  switch (action.type) {
    case 'DEVICE_CONNECTED':
      return { ...state, data: action.payload };
    case 'DEVICE_DISCONNECTED':
      return { ...state, data: action.payload };
    case 'DEVICE_FAILED':
      return { ...state, data: action.payload };
    case 'CAPTURE_STARTED':
      return { ...state, data: action.payload };
    case 'CAPTURE_STOPED':
      return { ...state, data: action.payload };
    default:
      return state
  }
}